import { useState } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { fileUrl } from "@/lib/api";

/**
 * Shared gallery component: main image + thumbnail strip + click-to-lightbox.
 * Used by all catalog categories (Nuevos, Seminuevos, Promociones).
 */
export function UnitGallery({ imagenPrincipal, galeria = [], titulo }) {
  const all = [imagenPrincipal, ...galeria].filter(Boolean);
  const [active, setActive] = useState(0);
  const [lightbox, setLightbox] = useState(false);

  if (all.length === 0) return null;

  const clamp = (i) => (i + all.length) % all.length;
  const prev = () => setActive((i) => clamp(i - 1));
  const next = () => setActive((i) => clamp(i + 1));

  return (
    <div data-testid="unit-gallery">
      <button
        type="button"
        onClick={() => setLightbox(true)}
        className="block aspect-[4/3] w-full overflow-hidden rounded-sm border border-[#3E5641]/10 bg-[#F1F3F3]"
        aria-label="Ampliar imagen"
        data-testid="unit-gallery-main"
      >
        <img src={fileUrl(all[active])} alt={titulo} className="h-full w-full object-cover" />
      </button>
      {all.length > 1 && (
        <div className="mt-3 grid grid-cols-5 gap-2 md:grid-cols-6">
          {all.map((p, i) => (
            <button
              key={p + i}
              type="button"
              onClick={() => setActive(i)}
              className={`aspect-square overflow-hidden border transition-colors ${
                i === active ? "border-[#A0553F]" : "border-[#3E5641]/10 hover:border-[#3E5641]/30"
              }`}
              aria-label={`Foto ${i + 1}`}
              data-testid={`unit-gallery-thumb-${i}`}
            >
              <img src={fileUrl(p)} alt="" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}

      {lightbox && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
          onClick={() => setLightbox(false)}
          data-testid="unit-gallery-lightbox"
        >
          <button
            className="absolute right-4 top-4 rounded-sm bg-white/10 p-2 text-white hover:bg-white/20"
            onClick={() => setLightbox(false)}
            aria-label="Cerrar"
            data-testid="unit-gallery-close"
          >
            <X size={20} />
          </button>
          {all.length > 1 && (
            <>
              <button
                className="absolute left-4 top-1/2 -translate-y-1/2 rounded-sm bg-white/10 p-2 text-white hover:bg-white/20"
                onClick={(e) => { e.stopPropagation(); prev(); }}
                aria-label="Anterior"
                data-testid="unit-gallery-prev"
              >
                <ChevronLeft size={22} />
              </button>
              <button
                className="absolute right-4 top-1/2 -translate-y-1/2 rounded-sm bg-white/10 p-2 text-white hover:bg-white/20"
                onClick={(e) => { e.stopPropagation(); next(); }}
                aria-label="Siguiente"
                data-testid="unit-gallery-next"
              >
                <ChevronRight size={22} />
              </button>
            </>
          )}
          <img
            src={fileUrl(all[active])}
            alt={titulo}
            className="max-h-[85vh] max-w-[92vw] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
